import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CommonMyApComponent} from './common-my-ap.component';
import {ActionPointListModule} from '../action-point-list/action-point-list.module';
import {TranslateDirective, TranslatePipe} from '@ngx-translate/core';


@NgModule({
  declarations: [CommonMyApComponent],
  imports: [
    CommonModule,
    ActionPointListModule,
    TranslatePipe,
    TranslateDirective,
  ],
  exports: [CommonMyApComponent]
})
export class CommonMyApModule {
}
